import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p>&copy; {new Date().getFullYear()} Tecollab AB. Alla rättigheter förbehållna.</p>
          <button onClick={scrollToTop} className="back-to-top">
            Tillbaka till toppen ↑
          </button>
        </div>
        <div className="footer-right">
          <p className="privacy-notice">
            Denna webbplats använder Google Analytics för att förbättra användarupplevelsen. 
            Inga personuppgifter lagras. Läs vår{' '}
            <a 
              href="https://csbf43f4d4183bbx455ex901.blob.core.windows.net/public/Tecollab%20Privacy%20Policy.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Integritetspolicy
            </a>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;